/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_ContentInputs */

const en_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Content`)
};

const es_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido premium`)
};

const fr_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu Premium`)
};

const de_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-Inhalt`)
};

const ja_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレミアムコンテンツ`)
};

const zh_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级内容`)
};

const ar_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محتوى مميز`)
};

const id_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten Premium`)
};

const it_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuto Premium`)
};

const ru_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум-контент`)
};

const pt_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo Premium`)
};

const ko_premium_content = /** @type {(inputs: Premium_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄 콘텐츠`)
};

/**
* | output |
* | --- |
* | "Premium Content" |
*
* @param {Premium_ContentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const premium_content = /** @type {((inputs?: Premium_ContentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_ContentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_premium_content(inputs)
	if (locale === "es") return es_premium_content(inputs)
	if (locale === "fr") return fr_premium_content(inputs)
	if (locale === "de") return de_premium_content(inputs)
	if (locale === "ja") return ja_premium_content(inputs)
	if (locale === "zh") return zh_premium_content(inputs)
	if (locale === "ar") return ar_premium_content(inputs)
	if (locale === "id") return id_premium_content(inputs)
	if (locale === "it") return it_premium_content(inputs)
	if (locale === "ru") return ru_premium_content(inputs)
	if (locale === "pt") return pt_premium_content(inputs)
	return ko_premium_content(inputs)
});